<wk-settings-breadcrumb (breadcrumbNavigate)="onBreadcrumbNavigate($event)" />

<wk-dashboard-select
    [showDashboardRenameOption]="false"
    (canChangeDashboard)="canChangeDashboard($event)"
    (dashboardChangeCompleted)="dashboardChangeCompleted($event)"
/>
<div class="wk-sm__container">
    <div class="wk-sm__header">
        <span class="wk-sm__header-title">
            @if (isJobsBillingDashboard) {
                {{ "Settings.MappingLabel_JobsAndBilling" | translate }}
            } @else {
                {{ "Settings.MappingLabel" | translate }}
            }
        </span>
    </div>

    <div class="wk-sm__content">
        <div class="wk-sm__section wk-sm__section-mapping">
            <div class="wk-sm__section__titles">
                <div class="wk-sm__section__title wk-sm__section__title--state">{{ "Settings.Views" | translate }}</div>
                <div class="wk-sm__section__title wk-sm__section__title--columns">{{ "Settings.Steps" | translate }}</div>
                <div class="wk-sm__section__title wk-sm__section__title--status">
                    @if (isJobsBillingDashboard) {
                        {{ "Settings.TaxprepStatus_JobsAndBilling" | translate }}
                    } @else {
                        {{ "Settings.TaxprepStatus" | translate }}
                    }
                </div>
            </div>
            <div class="wk-sm__section__list fancy-scrollbar-newUI" cdkScrollable>
                <div class="wk-sm__section__list__item wk-sm__section__list__item--not-started">
                    <div class="wk-sm__section__list__item-title">{{ "Dashboard.NotStarted" | translate }}</div>
                    <div class="wk-sm__section__list__item-container">
                        <wk-drop-list
                            id="not-started-status-columns"
                            groupId="columns"
                            [cdkDropListData]="mappingViewmodel.notStarted"
                            [cdkDropListDisabled]="mappingViewmodel.notStarted?.length <= 1 || isDashboardChanging"
                            [cdkDropListAutoScrollDisabled]="false"
                            cdkDropListOrientation="horizontal"
                            (drop)="onDrop()"
                            class="wk-sm__section__list__item-columns"
                        >
                            @for (column of mappingViewmodel.notStarted; track column.Id) {
                                <wk-drag [cdkDragData]="column">
                                    <wk-setting-mapping-column
                                        class="wk-sm__section__list__item-column"
                                        [class.thisIsIE]="thisIsIE"
                                        [class.cursor-move]="mappingViewmodel.notStarted.length > 1"
                                        [class.cursor-pointer]="mappingViewmodel.notStarted.length <= 1"
                                        [class.not-started]="true"
                                        [column]="column"
                                        [order]="$index"
                                        columnType="notStarted"
                                        [mappingViewmodel]="mappingViewmodel"
                                        [isJobsBillingDashboard]="isJobsBillingDashboard"
                                        (onFormChanged)="onMappingStatusFormChanged($event)"
                                        (onDeleteStep)="onDeleteStep($event)"
                                    />
                                </wk-drag>
                            }
                        </wk-drop-list>
                        <div class="wk-sm__section__list__item-add" [class.wk-drag-dragging]="isDragging" (click)="addNewColumn('notStarted')">+</div>
                    </div>
                </div>
                <div class="wk-sm__section__list__item wk-sm__section__list__item--active">
                    <div class="wk-sm__section__list__item-title">{{ "Dashboard.Active" | translate }}</div>
                    <div class="wk-sm__section__list__item-container">
                        <wk-drop-list
                            id="active-status-columns"
                            groupId="columns"
                            [cdkDropListData]="mappingViewmodel.active"
                            [cdkDropListDisabled]="mappingViewmodel.active?.length <= 1 || isDashboardChanging"
                            [cdkDropListAutoScrollDisabled]="false"
                            cdkDropListOrientation="horizontal"
                            (drop)="onDrop()"
                            class="wk-sm__section__list__item-columns"
                        >
                            @for (column of mappingViewmodel.active; track column.Id) {
                                <wk-drag [cdkDragData]="column">
                                    <wk-setting-mapping-column
                                        class="wk-sm__section__list__item-column"
                                        [class.thisIsIE]="thisIsIE"
                                        [class.cursor-move]="mappingViewmodel.active.length > 1"
                                        [class.cursor-pointer]="mappingViewmodel.active.length <= 1"
                                        [class.active]="true"
                                        [column]="column"
                                        [order]="$index"
                                        columnType="active"
                                        [isJobsBillingDashboard]="isJobsBillingDashboard"
                                        [mappingViewmodel]="mappingViewmodel"
                                        (onFormChanged)="onMappingStatusFormChanged($event)"
                                        (onDeleteStep)="onDeleteStep($event)"
                                    />
                                </wk-drag>
                            }
                        </wk-drop-list>
                        <div class="wk-sm__section__list__item-add" [class.wk-drag-dragging]="isDragging" (click)="addNewColumn('active')">+</div>
                    </div>
                </div>
                <div class="wk-sm__section__list__item wk-sm__section__list__item--completed">
                    <div class="wk-sm__section__list__item-title">{{ "Dashboard.Completed" | translate }}</div>
                    <div class="wk-sm__section__list__item-container">
                        <wk-drop-list
                            id="completed-status-columns"
                            groupId="columns"
                            [cdkDropListData]="mappingViewmodel.completed"
                            [cdkDropListDisabled]="mappingViewmodel.completed?.length <= 1 || isDashboardChanging"
                            [cdkDropListAutoScrollDisabled]="false"
                            cdkDropListOrientation="horizontal"
                            (drop)="onDrop()"
                            class="wk-sm__section__list__item-columns"
                        >
                            @for (column of mappingViewmodel.completed; track column.Id) {
                                <wk-drag [cdkDragData]="column">
                                    <wk-setting-mapping-column
                                        class="wk-sm__section__list__item-column"
                                        [class.thisIsIE]="thisIsIE"
                                        [class.cursor-move]="mappingViewmodel.completed.length > 1"
                                        [class.cursor-pointer]="mappingViewmodel.completed.length <= 1"
                                        [class.completed]="true"
                                        [column]="column"
                                        [order]="$index"
                                        columnType="completed"
                                        [isJobsBillingDashboard]="isJobsBillingDashboard"
                                        [mappingViewmodel]="mappingViewmodel"
                                        (onFormChanged)="onMappingStatusFormChanged($event)"
                                        (onDeleteStep)="onDeleteStep($event)"
                                    />
                                </wk-drag>
                            }
                        </wk-drop-list>
                        <div class="wk-sm__section__list__item-add" [class.wk-drag-dragging]="isDragging" (click)="addNewColumn('completed')">+</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wk-sm__section wk-sm__section-unassigned" [class.wk-sm__section-unassigned--jobs-billing]="isJobsBillingDashboard">
            <div class="wk-sm__section__titles">
                <div class="wk-sm__section__title wk-sm__section__title--unassigned">{{ "Settings.NotMappedStatuses" | translate }}</div>
            </div>
            <div class="wk-sm__section__list" [class.wk-sm__section__list--jobs-billing]="isJobsBillingDashboard">
                <wk-drop-list
                    #unassignedStatusList
                    id="unassigned-status-list"
                    groupId="status"
                    [cdkDropListData]="mappingViewmodel.unassigned"
                    [cdkDropListDisabled]="isDashboardChanging"
                    [cdkDropListAutoScrollDisabled]="false"
                    cdkDropListOrientation="horizontal"
                    (drop)="onDrop()"
                    class="fancy-scrollbar-newUI"
                    [class.fancy-scrollbar-newUI--has-scrollbar]="unassignedStatusListHasScrollbar()"
                >
                    @for (statusItem of mappingViewmodel.unassigned; track statusItem.Id) {
                        <wk-drag [cdkDragData]="statusItem" [class.wk-drag--jobs-billing]="isJobsBillingDashboard">
                            <wk-setting-mapping-status
                                class="wk-sm__section__list__item-column"
                                [class.thisIsIE]="thisIsIE"
                                [statusItem]="statusItem"
                                [isJobsBillingDashboard]="isJobsBillingDashboard"
                                (onFormChanged)="onMappingStatusFormChanged($event)"
                            />
                        </wk-drag>
                    }
                </wk-drop-list>
            </div>
        </div>
    </div>
    <div class="wk-sm__actions">
        <button class="btn-primary wk-sm__actions-save" [disabled]="!isFormChanged" (click)="onSave()">
            @if (settingMappingModelService.isSaving > 0) {
                <app-loader [isOverlay]="false" size="button" />
            }
            {{ "Settings.Save" | translate }}
        </button>
        <button class="btn-secondary wk-sm__actions-cancel" (click)="onCancel()">{{ "General.Close" | translate }}</button>
    </div>
</div>
<div kendoDialogContainer></div>
